<div class="border-grey-light header-container">
  <div class="row gap-22 mobile-row">
    <div class="col-md col-2 col-xs-4 border-blue"></div>

    <div class="col-md col-2 col-xs-4 border-blue"></div>

    <div class="col-md col-2 col-xs-4 border-blue"></div>
  </div>

  <div class="row d-flex justify-content-end mg-top-8">
    <p>Passo 3 de 3</p>
  </div>
  <h5 class="mg-top-16 mg-bottom-16">Finalização do cadastro</h5>
  <p class="p-text-grey mg-bottom-32">
    Complete as informações necessárias para começar a operar na plataforma.
  </p>
</div>

<div class="padding-16 container-border">
  <div class="row mg-bottom-16">
    <h6>Envio das documentações</h6>
  </div>

  <ng-container>
    <div
      class="row header-name titles border-grey-light d-flex justify-content-between"
    >
      <ng-container *ngIf="!individualDocument?.name">
        <div class="row gap-10 title-company">
          <img alt="" src="assets/image/1-icon.svg" />
          <h6 class="mg-top-10">Documentos de identificação</h6>
        </div>
        <img alt="" src="assets/image/loading-icon.svg" />
      </ng-container>

      <ng-container *ngIf="individualDocument?.name">
        <div class="row gap-10 title-company">
          <img
            alt=""
            [src]="
              isValidDocument
                ? 'assets/image/1-icon-green.svg'
                : 'assets/image/1-icon.svg'
            "
          />
          <h6 class="mg-top-10">Documentos de identificação</h6>
        </div>
        <img
          alt=""
          [src]="
            isValidDocument
              ? 'assets/image/check-green.svg'
              : 'assets/image/loading-icon.svg'
          "
        />
      </ng-container>
    </div>

    <div>
      <ng-container *ngIf="!isMobile">
        <input
          (change)="uploadDocumentFile(1, $event)"
          #documentFile
          style="display: none"
          type="file"
        />
        <div
          *ngIf="!individualDocument?.name"
          class="row d-flex row-no-file justify-content-between"
          (click)="documentFile.click()"
        >
          <div class="file-no-anexado">
            <img alt="" src="assets/image/document-add-icon.svg" />
            <p class="align-self-center title">RG, CNH ou Passaporte</p>
            <p class="format-text">Formatos aceitos .pdf .doc .png e .jpg</p>
          </div>

          <div class="file-anexar border-grey-light">
            <p class="p-text-grey align-self-center">
              <strong class="pointer">Anexar</strong>
            </p>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="isMobile">
        <input
          (change)="uploadDocumentFile(1, $event)"
          #documentFile
          style="display: none"
          type="file"
        />
        <div
          *ngIf="!individualDocument?.name"
          class="row d-flex row-no-file justify-content-between"
          (click)="documentFile.click()"
        >
          <div class="file-no-anexado">
            <div class="row-mobile">
              <div class="d-flex justify-content-center mb-2">
                <img alt="" src="assets/image/document-add-icon.svg" />
              </div>

              <p class="align-self-center title text-center mb-1">
                RG, CNH ou Passaporte
              </p>
              <p class="format-text text-center mb-2 formatos">
                Formatos aceitos .pdf .doc .png e .jpg
              </p>
            </div>
          </div>

          <div class="file-anexar mt-3">
            <p class="p-text-grey align-self-center">
              <strong class="pointer">Anexar</strong>
            </p>
          </div>
        </div>
      </ng-container>

      <div
        *ngIf="individualDocument?.name"
        class="row d-flex row-file justify-content-between"
      >
        <div class="file-anexado">
          <div class="img-delete">
            <img alt="" src="assets/image/document-icon.svg" />
          </div>
          <p class="p-text-grey align-self-center">
            {{ individualDocument?.name }}
          </p>
        </div>

        <div *ngIf="loadingValidation" class="file-removed border-grey-light">
          <p class="p-text-blue align-self-center">
            <strong class="mr-2">Validando documento ...</strong>
            <span class="spinner-border spinner-border-sm"></span>
          </p>
        </div>

        <div
          *ngIf="!loadingValidation"
          (click)="resetDocumentFile()"
          class="file-removed border-grey-light"
        >
          <p class="text-danger align-self-center">
            <strong>Remover documento</strong>
          </p>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="row mg-top-32">
    <div class="col-md-12">
      <div class="d-flex checkbox-confirm gap-10">
        <mat-checkbox [(ngModel)]="confirmData" name="accept-form">
        </mat-checkbox>

        <p class="p-text-grey">
          Confirmo que as informações estão corretas e atualizadas.
        </p>
      </div>
    </div>
  </div>
</div>

<div
  class="row buttons-confirm d-flex justify-content-between padding-bottom-32 padding-left-20 mg-top-24"
>
  <button
    id="btn-primary-return"
    class="btn btn-block btn-outline-primary"
    type="button"
    (click)="goBack()"
  >
    Voltar
  </button>

  <button
    [disabled]="formInvalid()"
    class="btn btn-dark-primary-blue-pf"
    type="button"
    (click)="update()"
  >
    Avançar
    <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
  </button>
</div>
